export const categoryToSearchQuery = {
  MARKETING: 'marketing',
  SALES: 'sales',
  SERVICE: 'service'
};
export const toolToSearchQuery = {
  MARKETING_HUB_TOOLS: 'marketing',
  SALES_HUB_TOOLS: 'sales',
  SERVICE_HUB_TOOLS: 'service'
};